import { render, staticRenderFns } from "./FileManagerExtend.vue?vue&type=template&id=65b8fc82&"
import script from "./FileManagerExtend.vue?vue&type=script&lang=js&"
export * from "./FileManagerExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports